module.exports = __webpack_public_path__ + "static/media/CAN events Accenture first quarterly event.28d105d2.jpg";